import { render } from "./MfMarkdownEditor.vue?vue&type=template&id=4b07872a&scoped=true"
import script from "./MfMarkdownEditor.vue?vue&type=script&lang=js"
export * from "./MfMarkdownEditor.vue?vue&type=script&lang=js"

import "./MfMarkdownEditor.vue?vue&type=style&index=0&id=4b07872a&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b07872a"]])

export default __exports__